// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var RendererDocking;
(function (RendererDocking) {
    RendererDocking[RendererDocking["Left"] = 0] = "Left";
    RendererDocking[RendererDocking["Right"] = 1] = "Right";
})(RendererDocking || (RendererDocking = {}));
